'use strict';

var util = require('../util'),
	dialog = require('../dialog'),
	address = require('./checkout/address'),
	loqate = require('../loqate'),
	validator = require('../validator'),
	progress = require('../progress'),
	ajax = require('../ajax'),
	linchpin = require('int_googletagmanager/linchpin/account');

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents () {
	$('.inventing-subscriptions .cancel-subscription').on('click', function () {
		var subscriptionID = $(this).parents('.subscription-container').find('.subscription-id').val();
		dialog.open({
			url: Urls.irCancel,
			options: {
				dialogClass: 'ir-cancel-dialog',
				open: function () {
					$('#cancel-reason').on('change', function () {
						var reason = $(this).val();
						if (reason === '1') {
							$('.cancel-dialog .other-reason').removeClass('visually-hidden');
						} else {
							$('.cancel-dialog .other-reason').addClass('visually-hidden');
						}
					});
				},
				buttons: [
					{
						text: Resources.CANCEL_SUBSCRIPTION_SUBMIT,
						click: function () {
							var reasonValue = $('#cancel-reason').val();
							var reasonText = $('#cancel-reason option:selected').text();
							// handle customer input for 'other' reason
							if (reasonValue === '1') {
								reasonText = $('.cancel-dialog .other-reason').val();
							}
							var reason = reasonValue + '|' + reasonText;
							cancelSubscription(subscriptionID, reason);
						}
					},
					{
						text: Resources.CANCEL_SUBSCRIPTION_CLOSE,
						click: function () {
							dialog.close();
						}
					}
				],
				title: Resources.CANCEL_SUBSCRIPTION_TITLE
			}
		});
	});
	$('.inventing-subscriptions .pause-subscription').on('click', function () {
		var orderID = $(this).parents('.subscription-container').find('.order-id').val();
		var subscriptionPlace = $(this).parents('.subscription-container').find('.subscription-place-date').val();
		var productID = $(this).parents('.subscription-container').find('.subscription-product').val();
		var frequency = $(this).parents('.subscription-container').find('.subscription-frequency').val();
		ajax.getJson({
			url: Urls.irPause,
			data: {
				orderID: orderID,
				placeDate: subscriptionPlace,
				productID: productID,
				frequency: frequency
			},
			callback: function (response) {
				if (response.success) {
					window.location.reload();
				} else {
					$('.inventing-room-error').removeClass('visually-hidden');
				}
			}
		});
	});
	$('.inventing-subscriptions .edit-shipping').on('click', function (e) {
		e.preventDefault();
		var $source = $(this).parents('.subscription-container');
		dialog.open({
			url:  Urls.irAddressEdit,
			options: {
				dialogClass: 'shipping-address-dialog inventing-room',
				open: function () {
					initializeAddressForm();
					address.pcaDialogIEFix('.shipping-address-dialog');
					populateAddress($source);
					loqate.init($('form.address-form'));
					initAddressButtons();
				},
				buttons: [],
				title: Resources.CANCEL_SUBSCRIPTION_TITLE
			}
		});
	});
}

function populateAddress ($source) {
	var $destForm = $('.shipping-address-dialog.inventing-room');
	$source.find('.edit-address-content input').each(function () {
		var $sourceField = $(this);
		var fieldName = $sourceField.attr('name');
		var $destField = $destForm.find('[name*="' + fieldName + '"]');
		if ($sourceField.val() && $sourceField.val() !== 'null') {
			$destField.val($sourceField.val());
		}
	});
	var subscriptionID = $source.find('.subscription-id').val();
	$destForm.find('[name="subscriptionID"]').val(subscriptionID);
}

function initializeAddressForm () {
	// Removes focus from select drop-down list when overlay is clicked
	$('.ui-widget-overlay').bind('click', function () {
		$('select').each(function () {
			$(this).blur();
		});
	});

	var $form = $('#edit-address-form');
	$form.find('select').uniform();

	address.dynamicAddressFieldsHandler($form);
	$form.find('input[name="format"]').remove();
	validator.initForm($form);

	$('input[type="text"][name^="dwfrm_profile_address_"][name$="name"]', $form).on('change', function () {
		this.value = util.replaceInvalidChars(this.value);
	});

	$form.on('click', '.apply-button', function (e) {
		e.preventDefault();
		if (!$form.valid()) {
			return false;
		}
		$('<input/>').attr({
			name: $(this).attr('name'),
			type: 'hidden'
		}).appendTo($form);

		var options = {
			url: $form.attr('action'),
			data: $form.serialize() + '&format=ajax',
			type: 'POST'
		};

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.addNewAddressEvent(e);
		}
		dialog.close();
		progress.show($('#addresses'));
		$.ajax(options).always(function (data) {
			progress.hide();
			if (data && data.success) {
				window.location.reload();
			} else {
				// TODO error after address form submission
			}
		});
	})
	.on('click', '.cancel-button, .close-button', function (e) {
		e.preventDefault();
		dialog.close();
	});
}

function initAddressButtons() {
	$('.inventing-room [name*="_address_cancel"]').on('click', function (e) {
		e.preventDefault();
		dialog.close();
	});
	$('.inventing-room [name*="_address_edit"]').on('click', function (e) {
		e.preventDefault();
		var data;
		ajax.getJson({
			url: Urls.irAddressUpdate,
			data: data,
			callback: function (response) {
				dialog.close();
				if (response.success) {
					window.location.reload();
				} else {
					$('.inventing-room-error').removeClass('visually-hidden');
				}
			}
		});
	});
}

function cancelSubscription(subscriptionID, reason) {
	ajax.getJson({
		url: Urls.irCancelProcess,
		data: {
			subscriptionID: subscriptionID,
			reason: reason
		},
		callback: function (response) {
			dialog.close();
			if (response.success) {
				window.location.reload();
			} else {
				$('.inventing-room-error').removeClass('visually-hidden');
			}
		}
	});
}

var inventingroom = {
	init: function () {
		initializeEvents();
	}
};

module.exports = inventingroom;
